import type { IBase } from '@/interfaces/base/IBase'
import DecoratorTypes from '@/enum/DecoratorTypes'
import Base from './Base'

class DecoratorBase extends Base  {
  constructor(entity: any) {
    super(entity)
  }

  private static propertyMap: { [key in DecoratorTypes]?: string[] } = {
    [DecoratorTypes.Displayable]: [],
    [DecoratorTypes.Required]: [],
  }

  static getAnnotatedProperties(decoratorType: DecoratorTypes): string[] {
    if (!this.propertyMap[decoratorType]) {
      this.propertyMap[decoratorType] = []
    }
    return this.propertyMap[decoratorType]!
  }

  static addAnnotatedProperty(decoratorType: DecoratorTypes, propertyName: string): void {
    const properties = this.getAnnotatedProperties(decoratorType)
    if (!properties.includes(propertyName)) {
      properties.push(propertyName)
    }
  }
}

export default DecoratorBase
